import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'session-analytic-item-view',
	templateUrl: './session-analytic-item-view.component.html',
	styleUrls: ['./session-analytic-item-view.component.scss'],
	standalone: false
})
export class SessionAnalyticItemViewComponent {
	@Input() public title: string;
	@Input() public dataSummary;
	@Input() public isExpanded = false;
	@Input() public shouldTease?: boolean = false;
	@Output() public onExpanded = new EventEmitter<boolean>();

	constructor () {}

	public toggleExpand () {
		this.isExpanded = !this.isExpanded;
		this.onExpanded.emit(this.isExpanded);
	}
}
